const initialState = {
  clientWarningStates: ['open', 'accepted', 'preparing'],
  confirmWhatsappWarning: true,
  printerConfig: {
    startType: 'auto',
    printerFormat: 'Cp1252',
    printType: 'new-printer',
  },
};

const ordersConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'UPDATE_PRINTER':
      return { ...state, printerConfig: action.printerConfig };
    case 'UPDATE_CLIENT_WARNING_STATES':
      return { ...state, clientWarningStates: action.clientWarningStates };
    case 'UPDATE_CONFIRM_WHATSAPP_WARNING':
      return { ...state, confirmWhatsappWarning: action.confirmWhatsappWarning };
    default:
      return state;
  }
};

export default ordersConfigReducer;
